import { createApiClient, RequestResponse } from 'src/lib/api-client'
import useSWR, { SWRConfiguration } from 'swr'

import { explanationCacheKey } from '../cacheKey'

type ExplanationReservationAbout = Extract<
  RequestResponse<
    '/trials/{trial_uid}/explanation_reservations/{explanation_reservation_uid}/about',
    'get'
  >,
  { result: 'success' }
>['data']

const getReservationAbout = async ({
  trialUid,
  explanationReservationUid,
}: {
  trialUid: string
  explanationReservationUid: string
}): Promise<ExplanationReservationAbout> => {
  const res = await createApiClient({
    path: '/trials/{trial_uid}/explanation_reservations/{explanation_reservation_uid}/about',
    httpMethod: 'get',
    params: {
      paths: {
        trial_uid: trialUid,
        explanation_reservation_uid: explanationReservationUid,
      },
    },
  }).request()

  if (res.result === 'error') {
    throw res.error
  }
  return res.data
}

export const useGetReservationAbout = ({
  trialUid,
  explanationReservationUid,
  ...option
}: {
  trialUid: string
  explanationReservationUid: string
} & SWRConfiguration<ExplanationReservationAbout, Error>) => {
  return useSWR(
    explanationCacheKey.getExplanationReservationAbout(
      trialUid,
      explanationReservationUid,
    ),
    () => getReservationAbout({ trialUid, explanationReservationUid }),
    option,
  )
}
